import './style.css';
import { App } from './core/App.js';

const app = new App();
app.start();
